import React from 'react';
import PropTypes from 'prop-types';
import { Marker as LeafletMarker, Popup } from 'react-leaflet-universal';

import { markerIcon } from 'utils';

import ProjectCard from 'components/ProjectCard';

import './Marker.scss';

class Marker extends React.Component {
    static propTypes = {
        location: PropTypes.string.isRequired,
        project: PropTypes.object,
        children: PropTypes.node,
        emphasize: PropTypes.bool,
        title: PropTypes.string.isRequired,
    }

    render() {
        const {
            children,
            emphasize,
            location,
            project,
            title,
        } = this.props;

        return (
            <LeafletMarker
                icon={markerIcon(project, emphasize, title)}
                position={location.split(",").map(parseFloat)}
            >
                {children}
                {project && (
                    <Popup>
                        <ProjectCard
                            {...project}
                            address={null}
                            compact
                            view="grid"
                            displayText={false}
                        />
                    </Popup>
                )}
            </LeafletMarker>
        );
    }
}

export default Marker;



// WEBPACK FOOTER //
// ./src/components/Marker/Marker.jsx